import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-azione-monitoria-view',
  templateUrl: './form-azione-monitoria-view.component.html',
  styleUrls: ['./form-azione-monitoria-view.component.css']
})
export class FormAzioneMonitoriaViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
